import { fetch } from 'cross-fetch';

import { isServer } from 'src/shared/helpers/environment';

const appendParametersToUrl = (
  url: URL | string,
  operationName: string = '',
) => {
  const clientId = isServer() ? 'web-react-server' : 'web-react';
  const nextUrl = new URL(url);
  nextUrl.searchParams.append('opname', operationName);
  nextUrl.searchParams.append('clientId', clientId);
  return nextUrl.toString();
};

const getOperationName = (init?: RequestInit) => {
  let operationName;
  try {
    const parsedBody = JSON.parse(String(init?.body)) as Record<string, string>;
    operationName = parsedBody.operationName;
  } catch {
    /* shouldn't happen */
  }

  return operationName || 'unknown';
};

function graphqlFetch(url: string, init?: RequestInit) {
  const nextUrl = appendParametersToUrl(url, getOperationName(init));

  return fetch(nextUrl, init);
}

export { graphqlFetch };
